module.exports = __webpack_public_path__ + "img/logo-white.da3c033e.png";